

// Hide qty selector manually

const gbInt = setInterval(()=>{

    const freeGiftsGrid = document.querySelectorAll(".#mini-cart .line-item .product-item-meta__title.text--small[href*='free-gift']") 
    console.log(freeGiftsGrid)
    if (freeGiftsGrid.length > 0) {
        freeGiftsGrid.forEach(g=>{
            g.closest(".line-item__info").querySelector(".line-item__quantity").style.visibility = "hidden"
        }
        )
    }
    }
    , 200)


